export default __webpack_public_path__ + "static/media/offer1.8ef50865.png";